import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';

//reemplazando valores de iniciales en estado

export default function ModalAccountConcept(props) {
  const accountConcept = props.model;

  const [dataChanging, setDataChanging] = useState({
    concepts: [],
    expense_centers: [],
    zones: []
  });
  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  const [concepts, setConcepts] = useState([]);
  const [costCenters, setCostCenters] = useState([]);
  const [zones, setZones] = useState([]);

  async function listConcepts() {
    let response = await wsGetAll('pymt/concept');
    if (response.success) setConcepts(response.data);
  }

  async function listCostCenters() {
    let response = await wsGetAll('pymt/expense-center');
    if (response.success) setCostCenters(response.data);
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  useEffect(() => {
    listConcepts();
    listCostCenters();
    listZones();
  }, []);

  return (
    <Modal
      title="Centro de costo"
      model={accountConcept}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      dataForce={{ pymt_account_id: props.idConcept }}
      entity="pymt/account-concept"
    >
      <Autocomplete
        multiple
        disableCloseOnSelect={true}
        size="small"
        options={concepts}
        getOptionLabel={(option) => option.description}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Concepto"
            margin="normal"
            required={dataChanging.concepts?.length === 0}
          />
        )}
        onChange={(e, items) => {
          if (!!items) {
            let arr = items.map((item) => {
              return item.id;
            });
            handleChange('concepts', arr);
          } else {
            handleChange('concepts', null);
          }
        }}
      />
      <Autocomplete
        multiple
        disableCloseOnSelect={true}
        size="small"
        options={costCenters}
        getOptionLabel={(option) => option.description}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Centros de costo"
            margin="normal"
            required={dataChanging.expense_centers?.length === 0}
          />
        )}
        onChange={(e, items) => {
          if (!!items) {
            let arr = items.map((item) => {
              return item.id;
            });
            handleChange('expense_centers', arr);
          } else {
            handleChange('expense_centers', null);
          }
        }}
      />
      <Autocomplete
        multiple
        disableCloseOnSelect={true}
        size="small"
        options={zones}
        getOptionLabel={(option) => option.description}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Zonas"
            margin="normal"
            required={dataChanging.zones?.length === 0}
          />
        )}
        onChange={(e, items) => {
          if (!!items) {
            let arr = items.map((item) => {
              return item.id;
            });
            handleChange('zones', arr);
          } else {
            handleChange('zones', null);
          }
        }}
      />
    </Modal>
  );
}
